export const defaultInvoiceStartNumber = "100";

type NormalizeInvoiceStartNumberInput = {
  value?: string | null;
};

export const normalizeInvoiceStartNumber = ({
  value,
}: NormalizeInvoiceStartNumberInput): string => {
  const trimmedValue = (value || "").trim();

  if (!/^\d+$/.test(trimmedValue)) {
    return defaultInvoiceStartNumber;
  }

  const valueWithoutLeadingZeros = trimmedValue.replace(/^0+(?=\d)/, "");

  return valueWithoutLeadingZeros === "0"
    ? defaultInvoiceStartNumber
    : valueWithoutLeadingZeros;
};
